module.exports = __webpack_public_path__ + "static/media/facebook.c0cd1382.svg";